var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40104 20.5333H0.734375V6.53333H5.40104V20.5333ZM3.06864 4.66667C1.77784 4.66667 0.734375 3.6204 0.734375 2.3324C0.734375 1.0444 1.77971 0 3.06864 0C4.35477 0 5.40104 1.04627 5.40104 2.3324C5.40104 3.6204 4.35477 4.66667 3.06864 4.66667ZM22.201 20.5333H17.7145V13.72C17.7145 12.0951 17.6837 10.0053 15.3821 10.0053C13.046 10.0053 12.6866 11.7749 12.6866 13.6024V20.5333H8.20104V6.52307H12.5074V8.43733H12.5681C13.1673 7.336 14.6317 6.17493 16.8157 6.17493C21.361 6.17493 22.201 9.07667 22.201 12.8492V20.5333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.95f492d50076b80c2313aa506cb45bac.svg";
export { ForwardRef as ReactComponent };